var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        visible: _vm.visible,
        title: _vm.title,
        "ok-title": _vm.okTitle,
        "cancel-title": _vm.cancelTitle,
        "ok-variant": "primary",
        "cancel-variant": "outline-secondary",
        size: "lg",
        "ok-only": "",
      },
      on: {
        ok: _vm.handleOk,
        cancel: _vm.handleCancel,
        hidden: _vm.handleCancel,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function (ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", disabled: !_vm.isFormValid },
                  on: {
                    click: function ($event) {
                      return ok()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.okTitle) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.cancelTitle) + " ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("p", { staticClass: "mb-3" }, [_vm._v(_vm._s(_vm.message))]),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Tipo de Remarcação",
            "label-for": _vm.modalId + "-schedule-type",
          },
        },
        [
          _c("b-form-radio-group", {
            staticClass: "mb-3",
            attrs: {
              id: _vm.modalId + "-schedule-type",
              options: _vm.scheduleTypeOptions,
            },
            on: { change: _vm.onScheduleTypeChange },
            model: {
              value: _vm.scheduleType,
              callback: function ($$v) {
                _vm.scheduleType = $$v
              },
              expression: "scheduleType",
            },
          }),
        ],
        1
      ),
      _vm.scheduleType === "available"
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Data",
                    "label-for": _vm.modalId + "-available-date",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: _vm.modalId + "-available-date",
                      type: "date",
                      state: _vm.availableDateValidationState,
                    },
                    on: { change: _vm.validateDateWithSchedule },
                    model: {
                      value: _vm.availableDate,
                      callback: function ($$v) {
                        _vm.availableDate = $$v
                      },
                      expression: "availableDate",
                    },
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.availableDateValidationState } },
                    [_vm._v(" " + _vm._s(_vm.availableDateError) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Horário Disponível",
                    "label-for": _vm.modalId + "-available-schedule",
                  },
                },
                [
                  _c("b-form-select", {
                    attrs: {
                      id: _vm.modalId + "-available-schedule",
                      options: _vm.availableScheduleOptions,
                      state: _vm.availableScheduleValidationState,
                    },
                    on: { change: _vm.validateDateWithSchedule },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "first",
                          fn: function () {
                            return [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null, disabled: "" } },
                                [_vm._v(" -- Selecione um horário -- ")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3523675857
                    ),
                    model: {
                      value: _vm.selectedAvailableScheduleId,
                      callback: function ($$v) {
                        _vm.selectedAvailableScheduleId = $$v
                      },
                      expression: "selectedAvailableScheduleId",
                    },
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.availableScheduleValidationState } },
                    [_vm._v(" Selecione um horário disponível ")]
                  ),
                  _vm.loadingSchedules
                    ? _c(
                        "small",
                        { staticClass: "text-muted" },
                        [
                          _c("b-spinner", { attrs: { small: "" } }),
                          _vm._v(" Carregando horários disponíveis... "),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.loadingSchedules && _vm.availableSchedules.length === 0
                    ? _c("small", { staticClass: "text-danger" }, [
                        _vm._v(" Nenhum horário disponível encontrado "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.scheduleType === "free"
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Nova Data",
                    "label-for": _vm.modalId + "-new-date",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: _vm.modalId + "-new-date",
                      type: "date",
                      state: _vm.newDateValidationState,
                    },
                    model: {
                      value: _vm.newDate,
                      callback: function ($$v) {
                        _vm.newDate = $$v
                      },
                      expression: "newDate",
                    },
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.newDateValidationState } },
                    [_vm._v(" A data é obrigatória ")]
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Horário Início",
                            "label-for": _vm.modalId + "-start-time",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: _vm.modalId + "-start-time",
                              type: "time",
                              state: _vm.startTimeValidationState,
                            },
                            model: {
                              value: _vm.startTime,
                              callback: function ($$v) {
                                _vm.startTime = $$v
                              },
                              expression: "startTime",
                            },
                          }),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.startTimeValidationState } },
                            [_vm._v(" O horário de início é obrigatório ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Horário Fim",
                            "label-for": _vm.modalId + "-end-time",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: _vm.modalId + "-end-time",
                              type: "time",
                              state: _vm.endTimeValidationState,
                            },
                            model: {
                              value: _vm.endTime,
                              callback: function ($$v) {
                                _vm.endTime = $$v
                              },
                              expression: "endTime",
                            },
                          }),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.endTimeValidationState } },
                            [_vm._v(" O horário de fim é obrigatório ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.justificationLabel,
            "label-for": _vm.modalId + "-justification",
          },
        },
        [
          _c("b-form-textarea", {
            attrs: {
              id: _vm.modalId + "-justification",
              rows: "4",
              placeholder: _vm.justificationPlaceholder,
              state: _vm.validationState,
            },
            model: {
              value: _vm.localJustification,
              callback: function ($$v) {
                _vm.localJustification = $$v
              },
              expression: "localJustification",
            },
          }),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.validationState } },
            [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }